/**
 * FusionMSI marketing hero gradients — sourced from @asi/design-tokens.
 */
import { darkTheme, lightTheme } from '@asi/design-tokens';

const { navyDeep, navy, secondaryDark, royalMid } = darkTheme.colors;

/** Dark-mode marketing page backdrop */
export const FUSION_MSI_MARKETING_GRADIENT_DARK = `linear-gradient(155deg, ${navyDeep} 0%, ${navy} 55%, ${secondaryDark} 100%)`;

/** Light-mode marketing page backdrop */
export const FUSION_MSI_MARKETING_GRADIENT_LIGHT = `linear-gradient(155deg, ${lightTheme.colors.primary} 0%, ${royalMid} 100%)`;
